const ships = {
  tanker1: {
    type: "tanker",
    typeDescr: "MR Tanker",
    typeDescr2: "50,000 MT DWT",
    particulars: {
      Lpp: 176.0,
      Lwl: 180.0,
      Loa: 183.2,
      B: 32.2,
      T: 12.6,
      D: 18.2,
      Cb: 0.85,
      Tballast: 6.0,
      Vmax: 16.0,
      Pme: 8600.0,
      Nme: 125.0,
      S: null,
      iE: null,
      YOB: 2010.0,
    },
    speedPower: [],
    propeller: {
      D: 6.0,
      curves: [],
      N: 1.0,
      Z: 5.0,
      AE_A0: null,
      P_D: null,
    },
    sfoc: {
      mainEngine: [],
      aux: 200.0,
    },
    defaultRotors: {
      h: 24.0,
      D: 4.0,
      placement: [
        [true, false, true, false],
        [false, false, false, false],
        [false, true, false, true],
      ]
    },
  },
  tanker2: {
    type: "tanker",
    typeDescr: "Aframax",
    typeDescr2: "110,000 MT DWT",
    particulars: {
      Lpp: 233.0,
      Lwl: 238.0,
      Loa: 244.5,
      B: 42.0,
      T: 15.5,
      D: 22.2,
      Cb: 0.83,
      Tballast: 6.0,
      Vmax: 16.0,
      Pme: 15000.0,
      Nme: 100.0,
      S: null,
      iE: null,
      YOB: 2008.0,
    },
    speedPower: [],
    propeller: {
      D: 7.0,
      curves: [],
      N: 1.0,
      Z: 5.0,
      AE_A0: null,
      P_D: null,
    },
    sfoc: {
      mainEngine: [],
      aux: 200.0,
    },
    defaultRotors: {
      h: 30.0,
      D: 5.0,
      placement: [
        [true, false, true, false],
        [false, false, false, false],
        [false, true, false, true],
      ]
    },
  },
  tanker3: {
    type: "tanker",
    typeDescr: "Suezmax",
    typeDescr2: "155,000 MT DWT",
    particulars: {
      Lpp: 267.0,
      Lwl: 272.0,
      Loa: 277.0,
      B: 48.0,
      T: 17.2,
      D: 23.1,
      Cb: 0.81,
      Tballast: 7.0,
      Vmax: 18.0,
      Pme: 16500.0,
      Nme: 75.0,
      S: null,
      iE: null,
      YOB: 2017.0,
    },
    speedPower: [],
    propeller: {
      D: 8.0,
      curves: [],
      N: 1.0,
      Z: 5.0,
      AE_A0: null,
      P_D: null,
    },
    sfoc: {
      mainEngine: [],
      aux: 200.0,
    },
    defaultRotors: {
      h: 30.0,
      D: 5.0,
      placement: [
        [true, false, false, true],
        [false, true, false, false],
        [true, false, false, true],
      ]
    },
  },
  tanker4: {
    type: "tanker",
    typeDescr: "VLCC",
    typeDescr2: "300,000 MT DWT",
    particulars: {
      Lpp: 320.0,
      Lwl: 327.0,
      Loa: 332.0,
      B: 58.0,
      T: 22.1,
      D: 31.2,
      Cb: 0.82,
      Tballast: 10.0,
      Vmax: 18.0,
      Pme: 25500.0,
      Nme: 75.0,
      S: null,
      iE: null,
      YOB: 2008.0,
    },
    speedPower: [],
    propeller: {
      D: 9.0,
      curves: [],
      N: 1.0,
      Z: 5.0,
      AE_A0: null,
      P_D: null,
    },
    sfoc: {
      mainEngine: [],
      aux: 200.0,
    },
    defaultRotors: {
      h: 30.0,
      D: 5.0,
      placement: [
        [true, false, true, false],
        [false, true, false, true],
        [true, false, true, false],
      ]
    },
  },
  bulkCarrier1: {
    type: "bulk carrier",
    typeDescr: "Handymax",
    typeDescr2: "45,000 MT DWT",
    particulars: {
      Lpp: 177.0,
      Lwl: 181.0,
      Loa: 186.0,
      B: 30.4,
      T: 11.6,
      D: 16.5,
      Cb: 0.83,
      Tballast: 6.0,
      Vmax: 16.0,
      Pme: 8600.0,
      Nme: 125.0,
      S: null,
      iE: null,
      YOB: 2001.0,
    },
    speedPower: [],
    propeller: {
      D: 6.0,
      curves: [],
      N: 1.0,
      Z: 5.0,
      AE_A0: null,
      P_D: null,
    },
    sfoc: {
      mainEngine: [],
      aux: 200.0,
    },
    defaultRotors: {
      h: 24.0,
      D: 4.0,
      placement: [
        [true, false, false, true],
        [false, false, false, false],
        [false, true, false, false],
      ]
    },
  },
  bulkCarrier2: {
    type: "bulk carrier",
    typeDescr: "Supramax",
    typeDescr2: "55,000 MT DWT",
    particulars: {
      Lpp: 182.0,
      Lwl: 185.0,
      Loa: 190.0,
      B: 32.2,
      T: 12.5,
      D: 17.9,
      Cb: 0.86,
      Tballast: 7.0,
      Vmax: 16.0,
      Pme: 9500.0,
      Nme: 125.0,
      S: null,
      iE: null,
      YOB: 2010.0,
    },
    speedPower: [],
    propeller: {
      D: 6.5,
      curves: [],
      N: 1.0,
      Z: 4.0,
      AE_A0: null,
      P_D: null,
    },
    sfoc: {
      mainEngine: [],
      aux: 200.0,
    },
    defaultRotors: {
      h: 24.0,
      D: 4.0,
      placement: [
        [true, false, true, false],
        [false, false, false, false],
        [false, true, false, true],
      ]
    },
  },
  bulkCarrier3: {
    type: "bulk carrier",
    typeDescr: "Kamsarmax",
    typeDescr2: "82,500 MT DWT",
    particulars: {
      Lpp: 225.0,
      Lwl: 227.0,
      Loa: 229.0,
      B: 32.2,
      T: 14.5,
      D: 20.2,
      Cb: 0.88,
      Tballast: 8.0,
      Vmax: 16.0,
      Pme: 10000.0,
      Nme: 90.0,
      S: null,
      iE: null,
      YOB: 2011.0,
    },
    speedPower: [],
    propeller: {
      D: 7.5,
      curves: [],
      N: 1.0,
      Z: 5.0,
      AE_A0: null,
      P_D: null,
    },
    sfoc: {
      mainEngine: [],
      aux: 200.0,
    },
    defaultRotors: {
      h: 24.0,
      D: 4.0,
      placement: [
        [true, false, true, false],
        [false, false, false, false],
        [false, true, false, true],
      ]
    },
  },
  bulkCarrier4: {
    type: "bulk carrier",
    typeDescr: "Capesize",
    typeDescr2: "180,000 MT DWT",
    particulars: {
      Lpp: 283.0,
      Lwl: 287.0,
      Loa: 292.0,
      B: 45.0,
      T: 18.2,
      D: 24.7,
      Cb: 0.87,
      Tballast: 10.0,
      Vmax: 17.0,
      Pme: 19000.0,
      Nme: 90.0,
      S: null,
      iE: null,
      YOB: 2010.0,
    },
    speedPower: [],
    propeller: {
      D: 8.5,
      curves: [],
      N: 1.0,
      Z: 5.0,
      AE_A0: null,
      P_D: null,
    },
    sfoc: {
      mainEngine: [],
      aux: 200.0,
    },
    defaultRotors: {
      h: 30.0,
      D: 5.0,
      placement: [
        [true, false, false, true],
        [false, true, false, false],
        [true, false, false, true],
      ]
    },
  },
  bulkCarrier5: {
    type: "bulk carrier",
    typeDescr: "VLOC",
    typeDescr2: "400,000 MT DWT",
    particulars: {
      Lpp: 353.0,
      Lwl: 357.0,
      Loa: 360.0,
      B: 65.0,
      T: 23.0,
      D: 30.0,
      Cb: 0.83,
      Tballast: 11.0,
      Vmax: 16.0,
      Pme: 29000.0,
      Nme: 75.0,
      S: null,
      iE: null,
      YOB: 2016.0,
    },
    speedPower: [],
    propeller: {
      D: 10.0,
      curves: [],
      N: 1.0,
      Z: 5.0,
      AE_A0: null,
      P_D: null,
    },
    sfoc: {
      mainEngine: [],
      aux: 200.0,
    },
    defaultRotors: {
      h: 30.0,
      D: 5.0,
      placement: [
        [true, false, true, false],
        [false, true, false, true],
        [true, false, true, false],
      ]
    },
  },
  roro1: {
    type: "ro-ro",
    typeDescr: "<1k lane meters",
    typeDescr2: "5,000 MT DWT",
    particulars: {
      Lpp: 110.5,
      Lwl: 113.0,
      Loa: 117.0,
      B: 18.0,
      T: 6.5,
      D: 12.0,
      Cb: 0.68,
      Tballast: 3.0,
      Vmax: 18.0,
      Pme: 4500.0,
      Nme: 150.0,
      S: null,
      iE: null,
      YOB: 2012.0,
    },
    speedPower: [],
    propeller: {
      D: 3.0,
      curves: [],
      N: 1.0,
      Z: 5.0,
      AE_A0: null,
      P_D: null,
    },
    sfoc: {
      mainEngine: [],
      aux: 200.0,
    },
    defaultRotors: {
      h: 15.0,
      D: 2.5,
      placement: [
        [false, false, false, false],
        [false, false, false, false],
        [true, false, true, false],
      ]
    },
  },
  roro2: {
    type: "ro-ro",
    typeDescr: "1-3k lane meters",
    typeDescr2: "10,000 MT DWT",
    particulars: {
      Lpp: 150.0,
      Lwl: 154.2,
      Loa: 162.7,
      B: 25.7,
      T: 6.7,
      D: 22.0,
      Cb: 0.68,
      Tballast: 4.0,
      Vmax: 20.0,
      Pme: 14500.0,
      Nme: 130.0,
      S: null,
      iE: null,
      YOB: 2000.0,
    },
    speedPower: [],
    propeller: {
      D: 4.3,
      curves: [],
      N: 2.0,
      Z: 5.0,
      AE_A0: null,
      P_D: null,
    },
    sfoc: {
      mainEngine: [],
      aux: 200.0,
    },
    defaultRotors: {
      h: 24.0,
      D: 4.0,
      placement: [
        [true, false, true, false],
        [false, false, false, false],
        [false, true, false, true],
      ]
    },
  },
  roro3: {
    type: "ro-ro",
    typeDescr: ">3k lane meters",
    typeDescr2: "25,000 MT DWT",
    particulars: {
      Lpp: 211.0,
      Lwl: 215.0,
      Loa: 225.0,
      B: 32.4,
      T: 9.5,
      D: 28.0,
      Cb: 0.66,
      Tballast: 6.0,
      Vmax: 20.0,
      Pme: 15500.0,
      Nme: 100.0,
      S: null,
      iE: null,
      YOB: 2015.0,
    },
    speedPower: [],
    propeller: {
      D: 5.0,
      curves: [],
      N: 1.0,
      Z: 5.0,
      AE_A0: null,
      P_D: null,
    },
    sfoc: {
      mainEngine: [],
      aux: 200.0,
    },
    defaultRotors: {
      h: 30.0,
      D: 5.0,
      placement: [
        [true, false, true, false],
        [false, false, false, false],
        [false, true, false, true],
      ]
    },
  },
  pax1: {
    type: "pax",
    typeDescr: "<10k GT",
    typeDescr2: "8,000 GT",
    particulars: {
      Lpp: 126.2,
      Lwl: 130.0,
      Loa: 141.0,
      B: 21.0,
      T: 5.3,
      D: 20.0,
      Cb: 0.61,
      Tballast: 4.5,
      Vmax: 28.0,
      Pme: 32000.0,
      Nme: 188.0,
      S: null,
      iE: null,
      YOB: 2005.0,
    },
    speedPower: [],
    propeller: {
      D: 3.8,
      curves: [],
      N: 2.0,
      Z: 5.0,
      AE_A0: null,
      P_D: null,
    },
    sfoc: {
      mainEngine: [],
      aux: 200.0,
    },
    defaultRotors: {
      h: 18.0,
      D: 3.0,
      placement: [
        [false, false, false, false],
        [true, false, true, false],
        [false, false, false, false],
      ]
    },
  },
  pax2: {
    type: "pax",
    typeDescr: "10-60k GT",
    typeDescr2: "57,500 GT",
    particulars: {
      Lpp: 200.0,
      Lwl: 204.0,
      Loa: 213.0,
      B: 32.0,
      T: 7.0,
      D: 31.0,
      Cb: 0.63,
      Tballast: 6.0,
      Vmax: 22.0,
      Pme: 21000.0,
      Nme: 125.0,
      S: null,
      iE: null,
      YOB: 2013.0,
    },
    speedPower: [],
    propeller: {
      D: 4.3,
      curves: [],
      N: 2.0,
      Z: 5.0,
      AE_A0: null,
      P_D: null,
    },
    sfoc: {
      mainEngine: [],
      aux: 200.0,
    },
    defaultRotors: {
      h: 24.0,
      D: 4.0,
      placement: [
        [false, false, false, false],
        [true, false, true, false],
        [false, false, false, false],
      ]
    },
  },
  pax3: {
    type: "pax",
    typeDescr: "60-100k GT",
    typeDescr2: "72,000 GT",
    particulars: {
      Lpp: 224.0,
      Lwl: 230.0,
      Loa: 262.0,
      B: 31.5,
      T: 8.0,
      D: 40.0,
      Cb: 0.63,
      Tballast: 7.0,
      Vmax: 24.0,
      Pme: 28000.0,
      Nme: 125.0,
      S: null,
      iE: null,
      YOB: 2000.0,
    },
    speedPower: [],
    propeller: {
      D: 6.0,
      curves: [],
      N: 2.0,
      Z: 5.0,
      AE_A0: null,
      P_D: null,
    },
    sfoc: {
      mainEngine: [],
      aux: 200.0,
    },
    defaultRotors: {
      h: 24.0,
      D: 4.0,
      placement: [
        [true, false, false, true],
        [false, false, false, false],
        [false, true, false, false],
      ]
    },
  },
  pax4: {
    type: "pax",
    typeDescr: ">100k GT",
    typeDescr2: "160,000 GT",
    particulars: {
      Lpp: 288.0,
      Lwl: 300.0,
      Loa: 330.0,
      B: 40.0,
      T: 9.0,
      D: 50.0,
      Cb: 0.63,
      Tballast: 8.0,
      Vmax: 25.0,
      Pme: 48000.0,
      Nme: 140.0,
      S: null,
      iE: null,
      YOB: 2010.0,
    },
    speedPower: [],
    propeller: {
      D: 7.0,
      curves: [],
      N: 2.0,
      Z: 5.0,
      AE_A0: null,
      P_D: null,
    },
    sfoc: {
      mainEngine: [],
      aux: 200.0,
    },
    defaultRotors: {
      h: 30.0,
      D: 5.0,
      placement: [
        [true, false, true, false],
        [false, false, false, false],
        [false, true, false, true],
      ]
    },
  },

}
export default ships